<app-card>
  <div *ngIf="student$ | async as student; else emptyTemplate" app-card-content class="grid w-full md:flex">
    <div class="flex w-full gap-5">
      <div class="flex gap-5" [ngClass]="{ 'w-full': !student.usuario_id }">
        <app-user-photo
          class="h-20 md:!h-24 xl:w-3/12"
          [height]="'h-20'"
          [width]="'md:!w-max'"
          [src]="student.foto"
        ></app-user-photo>
        <div class="grid items-center">
          <span class="text-md font-bold active:text-base-mantis-500 md:text-lg"> {{ student.nome }}</span>
          <span *ngIf="student.turma_descricao" class="active:text-base-mantis-500">
            {{ student.turma_descricao }}
          </span>
        </div>
      </div>
    </div>
    <div class="mt-5 flex w-full items-center justify-center md:mt-0 md:grid md:w-2/12 md:justify-end lg:w-3/12">
      <ng-container *ngIf="studentScore">
        <ng-container *ngIf="isPercent; else weightTemplate">
          {{ 'gestor-avaliacoes.percentual-de-acerto' | translate }}
          <span class="mx-2 text-md font-semibold md:text-2xl">
            {{ studentScore | currency : '' : '' : '1.0-0' }}%
          </span>
        </ng-container>
        <ng-template #weightTemplate>
          {{ 'gestor-avaliacoes.nota' | translate }}
          <span class="mx-2 text-md font-semibold md:text-2xl">
            {{ studentScore | currency : '' : '' : '1.2-2' }} / {{ score | currency : '' : '' : '1.2-2' }}</span
          >
        </ng-template>
      </ng-container>

      <ng-container *ngIf="onGetStatusLabel(student) as status">
        <span [ngClass]="status.class" class="rounded-full px-2 text-white">
          {{ status.text | translate }}
        </span>
      </ng-container>
    </div>
  </div>

  <ng-template #emptyTemplate>
    <div app-card-content class="grid w-full md:flex">
      <app-skeleton></app-skeleton>
    </div>
  </ng-template>
</app-card>
